import { render, staticRenderFns } from "./ScriveAddSignerRole.vue?vue&type=template&id=105cb591&"
import script from "./ScriveAddSignerRole.vue?vue&type=script&lang=ts&"
export * from "./ScriveAddSignerRole.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports